import { render, staticRenderFns } from "./OrgChecklist.vue?vue&type=template&id=45d2da98&scoped=true&"
import script from "./OrgChecklist.vue?vue&type=script&lang=js&"
export * from "./OrgChecklist.vue?vue&type=script&lang=js&"
import style0 from "./OrgChecklist.vue?vue&type=style&index=0&id=45d2da98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d2da98",
  null
  
)

export default component.exports